<template>
  <el-dialog
    title="推送ERP"
    :visible.sync="visible"
    width="420px"
    :close-on-click-modal="false"
  >
    <div style="text-align: center; padding: 30px 0">
      <span class="el-icon-warning yeler"></span> 确认将资料推送到ERP？
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="confirm">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { erpSendQualification } from "@/api/appApi/appapi.js";

export default {
  name: "PushErpDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      visible: this.value,
      loading: false,
    };
  },
  watch: {
    value(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    async confirm() {
      if (!this.customerId) {
        this.$message.warning("缺少推送ID");
        return;
      }
      this.loading = true;
      const res = await erpSendQualification({ id: this.customerId });
      this.loading = false;
      if (res.code == "000000") {
        this.$message.success("已同步ERP");
        this.visible = false;
        this.$emit("success");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>

